export default __webpack_public_path__ + "static/media/photo--lg--leena-4.243011b2.jpg";